import React, { useState } from "react";
import { navList } from "../../config/docFile";
import { Link, useLocation } from "react-router-dom";
import { useDrawerTransition } from "../../context/drawerProvider";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../redux/actions/language";
import Lang from "../../config/lang";
import '../../index.css'
import { changeLangParam } from "../../config/helper";

const Footer = ({ }) => {

    const dispatch = useDispatch();
    const { lang } = useSelector((state) => state.globalReducer);
    const { startTransition } = useDrawerTransition();
    const [openLang, setOpenLang] = useState(false);
    const location = useLocation();
    const isAccountPage =
        location.pathname.includes('/profile') ||
        location.pathname.includes('/my-application');

    return (
        <footer className={`h-fit bg-[#034694] p-8 md:p-16 pb-6 rounded-0 relative ${isAccountPage ? 'mt-8 md:mt-10' : '-mt-8'}`}>
            <div className='flex flex-col mx-auto w-[90%]'>
                <div className='flex flex-col md:flex-row justify-between font-normal mx-auto'>
                    <div className='flex flex-col gap-4 w-auto md:w-[50%]'>
                        <a className='w-[30%] md:w-[20%]'>
                            <img src="/asset/logosopra_white.png" />
                        </a>
                        <p className='text-[#FFFFFFCC] text-xs md:text-sm font-semibold text-justify'>{Lang(lang, 'footer_desc')}</p>
                        <div className="flex flex-row items-center pt-0 md:pt-4">
                            <a href='/portal' className="bg-[#EA2427] text-[#FFFFFF] hover:bg-white hover:text-[#EA2427] text-center rounded-full font-semibold text-sm py-1 px-4 mr-3" onClick={(e) => {
                                e.preventDefault();
                                startTransition(`/${lang}/portal`);
                            }}>{Lang(lang, 'explore_jobs')}</a>
                            <a className='w-[20%]'>
                                <img src="/asset/icon/wa.svg" />
                            </a>
                        </div>
                    </div>
                    <div className='md:flex flex-col gap-2 hidden'>
                        <p className='text-white font-bold text-base md:text-xl'>{Lang(lang, 'navigation')}</p>
                        {navList?.filter(obj => obj?.show === true)?.map((value, idx) => (
                            <a href={`/${lang}/${value?.path}`} className='text-[#FFFFFFCC] font-semibold text-xs md:text-sm' key={idx} onClick={(e) => {
                                e.preventDefault();
                                startTransition(`/${lang}/${value?.path}`);
                            }}>{Lang(lang, value.label)}</a>
                        ))}
                    </div>
                    <div className='md:flex flex-col gap-2 hidden'>
                        <p className='text-white font-bold text-base md:text-xl'>Let's Connect</p>
                        <div className="flex flex-row items-center gap-2">
                            <img className="w-[12px]" src="/asset/icon/ig.svg" />
                            <a className='text-[#FFFFFFCC] text-xs md:text-sm font-semibold' href="https://www.instagram.com/soprapack">Instagram</a>
                        </div>
                        <div className="flex flex-row items-center gap-2">
                            <img className="w-[12px]" src="/asset/icon/Linkedin.svg" />
                            <a className='text-[#FFFFFFCC] text-xs md:text-sm font-semibold' href="https://www.linkedin.com/company/pt-solusi-prima-packaging">Linkedin</a>
                        </div>
                        <div className="flex flex-row items-center gap-2">
                            <img className="w-[12px] h-[15px]" src="/asset/icon/facebook.svg" />
                            <a className='text-[#FFFFFFCC] text-xs md:text-sm font-semibold' href="https://www.facebook.com/soprapack">Facebook</a>
                        </div>
                        <div className="flex flex-row items-center gap-2">
                            <img className="w-[12px]" src="/asset/icon/tiktok.svg" />
                            <a className='text-[#FFFFFFCC] text-xs md:text-sm font-semibold' href="https://www.tiktok.com/@soprapack">Tiktok</a>
                        </div>
                    </div>

                    <div className='flex md:hidden flex-row gap-4 justify-between mt-4'>
                        <div className='flex flex-col gap-2'>
                            <p className='text-white font-bold text-base md:text-xl'>{Lang(lang, 'navigation')}</p>
                            {navList?.filter(obj => obj?.show === true)?.map((value, idx) => (
                                <a href={`/${lang}/${value?.path}`} className='text-[#FFFFFFCC] text-xs md:text-sm font-semibold' key={idx} onClick={(e) => {
                                    e.preventDefault();
                                    startTransition(`/${lang}/${value?.path}`);
                                }}>{Lang(lang, value.label)}</a>
                            ))}
                        </div>
                        <div className='flex flex-col gap-2'>
                            <p className='text-white font-bold text-base md:text-xl'>Let's Connect</p>
                            <div className="flex flex-row items-center gap-2">
                                <img className="w-[12px]" src="/asset/icon/ig.svg" />
                                <a className='text-[#FFFFFFCC] text-xs md:text-sm font-semibold' href="https://www.instagram.com/soprapack">Instagram</a>
                            </div>
                            <div className="flex flex-row items-center gap-2">
                                <img className="w-[12px]" src="/asset/icon/Linkedin.svg" />
                                <a className='text-[#FFFFFFCC] text-xs md:text-sm font-semibold' href="https://www.linkedin.com/company/pt-solusi-prima-packaging">Linkedin</a>
                            </div>
                            <div className="flex flex-row items-center gap-2">
                                <img className="w-[12px] h-[15px]" src="/asset/icon/facebook.svg" />
                                <a className='text-[#FFFFFFCC] text-xs md:text-sm font-semibold' href="https://www.facebook.com/soprapack">Facebook</a>
                            </div>
                            <div className="flex flex-row items-center gap-2">
                                <img className="w-[12px]" src="/asset/icon/tiktok.svg" />
                                <a className='text-[#FFFFFFCC] text-xs md:text-sm font-semibold' href="https://www.tiktok.com/@soprapack">Tiktok</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='mt-8 mb-4 white-flatline'></div>

                <div className='flex flex-row justify-between'>
                    <div className="flex flex-row gap-2 items-center relative cursor-pointer" onClick={() => setOpenLang(!openLang)}>
                        {openLang &&
                            <div className="rounded-lg py-2 bg-white absolute bottom-5 -right-5 flex flex-col gap-2 w-[88px]">
                                <p className="text-xs cursor-pointer hover:bg-[#e6e6e6cc] px-2" onClick={() => {
                                    dispatch(setLanguage('en'));
                                    changeLangParam('en')
                                }}>English</p>
                                <p className="text-xs cursor-pointer hover:bg-[#e6e6e6cc] px-2" onClick={() => {
                                    dispatch(setLanguage('id'));
                                    changeLangParam('id')
                                }}>Indonesia</p>
                            </div>
                        }
                        <img className="w-[15px]" src="/asset/icon/language.svg" />
                        <p className='text-[#FFFFFFCC] text-xs md:text-sm'>{lang === 'en' ? 'English' : 'Indonesia'}</p>
                        <img className="w-[12px]" src="/asset/icon/arrow_lang.svg" />
                    </div>
                    <p className='text-[#FFFFFFCC] text-xs md:text-sm text-right w-[60%] md:w-full'>© 2025 PT. Solusi Prima Packaging. All Right Reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
